/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/statistics/affiliate/export/{exportType}": {
    get: operations["ExportAffiliateMetricsController_exportMetrics"];
  };
  "/api/statistics/mobile/export/{exportType}": {
    get: operations["ExportMobileMetricsController_exportMetrics"];
  };
  "/api/statistics/trader/export/{exportType}": {
    get: operations["ExportTraderMetricsController_exportMetrics"];
  };
  "/api/v3/statistics/trader/settings": {
    get: operations["TraderMetricsSettingsController_getSettings"];
  };
  "/api/v3/statistics/affiliate/settings": {
    get: operations["AffiliateMetricsSettingsController_getSettings"];
  };
  "/api/ping": {
    get: operations["PingController_ping"];
  };
  "/api/auth/signup": {
    post: operations["SignupController_signup"];
  };
  "/api/auth/email-confirm": {
    post: operations["EmailConfirmController_confirm"];
  };
  "/api/auth/email-confirm/request": {
    post: operations["EmailConfirmController_request"];
  };
  "/api/auth/reset-password/request": {
    post: operations["ResetPasswordController_request"];
  };
  "/api/auth/reset-password/reset": {
    post: operations["ResetPasswordController_reset"];
  };
  "/api/dictionary/countries": {
    get: operations["CountriesController_countries"];
  };
  "/api/v3/countries": {
    get: operations["CountriesV3Controller_countries"];
  };
  "/api/v3/country-ip": {
    get: operations["CountriesV3IpController_countries"];
  };
  "/api/v3/user/onboarding": {
    post: operations["OnboardingController_pass"];
  };
  "/api/v3/user/onboarding/support-languages": {
    get: operations["OnboardingController_preferableLanguages"];
  };
  "/api/v3/user/phone/request-adding": {
    post: operations["PhoneController_requestAdding"];
  };
  "/api/v3/user/phone/request-removing": {
    post: operations["PhoneController_requestRemoving"];
  };
  "/api/v3/user/phone/remove": {
    post: operations["PhoneController_remove"];
  };
  "/api/v3/user/phone/add": {
    post: operations["PhoneController_add"];
  };
  "/api/v3/user/subscription/newsletter": {
    post: operations["SubscriptionController_newsletter"];
  };
  "/api/v3/statistics/afftracks": {
    get: operations["AffTracksController_getAffTracks"];
  };
  "/api/v3/statistics/referrals/afftracks": {
    get: operations["AffTracksController_getReferralsAffTracks"];
  };
  "/api/v3/user": {
    get: operations["AffiliateController_getAffiliate"];
    patch: operations["AffiliateController_updateProfile"];
  };
  "/api/v3/auth/reset-password": {
    post: operations["ChangePasswordController_post"];
  };
  "/api/payment-account/confirm/{token}": {
    get: operations["PaymentAccountController_confirm"];
  };
  "/api/support/access": {
    get: operations["AccessController_getToken"];
  };
  "/api/support/logout": {
    get: operations["LogoutController_getToken"];
  };
  "/api/support/assign/manager": {
    post: operations["AssignController_getToken"];
  };
  "/api/v3/payment-account/confirm/{token}": {
    post: operations["PaymentAccountControllerV3_confirm"];
  };
}

export interface components {
  schemas: {
    TraderMetricsSettingsResponse: {
      allowedFields: (
        | "traderId"
        | "affTrack"
        | "registerDate"
        | "metricsDate"
        | "cpaDate"
        | "tariff"
        | "country"
        | "platform"
        | "deposits"
        | "deals"
        | "inout"
        | "pnl"
        | "pnlRevenue"
        | "depositAmount"
        | "affModel"
        | "cpaDealsAmount"
        | "profit"
        | "advertiserId"
        | "isLead"
      )[];
      allowedFilters: (
        | "tariff"
        | "cpaDate"
        | "registerDate"
        | "metricsDate"
        | "traderId"
        | "affModels"
        | "advertiserIds"
        | "affTracks"
        | "countries"
        | "isLead"
        | "platforms"
      )[];
      allowedGroupings: (
        | "ByDay"
        | "ByTrader"
        | "ByWeek"
        | "ByMonth"
        | "ByCountry"
        | "ByAffTrack"
        | "ByAffiliateModel"
        | "ByAdvertiser"
        | "ByPlatform"
      )[];
    };
    AffiliateMetricsSettingsResponse: {
      allowedFields: (
        | "affTrack"
        | "affModel"
        | "date"
        | "countryId"
        | "combinedHits"
        | "combinedUniques"
        | "combinedProfit"
        | "installs"
        | "combinedRegistrations"
        | "conversion"
        | "deposits"
        | "ftd"
        | "deals"
        | "leads"
        | "clicks"
        | "platform"
        | "advertiserId"
      )[];
      allowedFilters: (
        | "countryId"
        | "countryRegulation"
        | "period"
        | "affTrack"
        | "tariff"
        | "affModels"
        | "platformGroup"
        | "advertiserIds"
        | "affTracks"
        | "countries"
      )[];
      allowedGroupings: (
        | "ByDay"
        | "ByWeek"
        | "ByMonth"
        | "ByCountry"
        | "ByRegulation"
        | "ByAffTrack"
        | "ByAffTrackAndDate"
        | "ByAffiliateModel"
        | "ByPlatformGroup"
        | "ByAdvertiser"
      )[];
    };
    SignupDto: {
      email: string;
      password: string;
      preferableLang: string;
      site: string;
      affTrack?: string;
      /** @description for referral system */
      refAccountId?: number;
      /** @description user referrer url */
      referrer?: string;
      /** @description for internal usage */
      source?: string;
      /** @description for internal usage */
      keyword?: string;
      agreementSigned: boolean;
    };
    ErrorResponseDto: {
      _global: {
        /** @description translation key of error */
        key?: string;
        params?: { [key: string]: string };
      };
      fields: {
        [key: string]: {
          /** @description translation key of error */
          key?: string;
          params?: { [key: string]: string };
        };
      };
    };
    EmailConfirmDto: {
      token: string;
    };
    RequestResetPasswordDto: {
      email: string;
      site: string;
    };
    ResetPasswordDto: {
      token: string;
      password: string;
    };
    CountryResponseDto: {
      id: number;
      name: string;
      code: string;
      phoneCode: number;
      restrictedPrograms: ("NONE" | "AFFILIATE" | "IB")[];
    };
    CountryResponseV3: {
      /**
       * @deprecated
       * @description use country.code
       */
      id: number;
      code: string;
      name: string;
      iso: string;
      phoneCode: number;
    };
    CountryResponseV3Ip: {
      code: string;
    };
    AlternativeContactQueryDto: {
      /** @enum {string} */
      type:
        | "skype"
        | "telegram"
        | "facebook"
        | "whatsapp"
        | "qq"
        | "viber"
        | "wechat"
        | "weibo"
        | "email"
        | "none";
      value: string;
    };
    OnboardingQueryDto: {
      /** @enum {string} */
      type: "Individual" | "LegalEntity";
      /** @enum {string} */
      program: "NONE" | "AFFILIATE" | "IB";
      firstName: string;
      lastName: string;
      companyName: string;
      representativesFirstName: string;
      representativesLastName: string;
      contact?: components["schemas"]["AlternativeContactQueryDto"];
      countryCode: string;
      preferableLang: string;
      trafficSource: string;
      trafficRegion: string;
      /** @enum {string} */
      workingExperience?: "Yes" | "No";
      partnershipExperience: string;
      /** @enum {string} */
      monthlyLeadsCount?: "GTE1" | "GTE3" | "GTE11" | "GTE100";
    };
    LanguagesResponseDto: {
      code: string;
    };
    RequestPhoneAddingDto: {
      phone: string;
    };
    ConfirmPhoneRemoveDto: {
      code: string;
    };
    ConfirmPhoneAddDto: {
      phone: string;
      code: string;
    };
    SubscriptionNewsletterQueryDto: {
      isSubscribed: boolean;
    };
    AlternativeContactResponseDto: {
      type: string;
      value: string;
    };
    AffManagerVacationResponseDto: {
      /** Format: date-time */
      dateFrom: string;
      /** Format: date-time */
      dateTo: string;
      /** @enum {string} */
      vacationType?:
        | "user.trip"
        | "user.vacation"
        | "user.sick"
        | "user.holidays";
    };
    AffManagerWorkingHoursResponseDto: {
      from: string;
      to: string;
    };
    AffManagerResponseDto: {
      id: number;
      accountId: number;
      /**
       * @deprecated
       * @description use field contacts;
       */
      email: string;
      firstName?: string;
      lastName?: string;
      isOnline: boolean;
      contacts: components["schemas"]["AlternativeContactResponseDto"][];
      vacation: components["schemas"]["AffManagerVacationResponseDto"];
      photo?: string;
      workingHours: components["schemas"]["AffManagerWorkingHoursResponseDto"];
    };
    AffiliateResponseDto: {
      id: number;
      accountId: number;
      email: string;
      /** Format: date-time */
      birthdate?: string;
      isSubscribedToNews: boolean;
      isActivated: boolean;
      /** @enum {string} */
      type: "Individual" | "LegalEntity";
      firstName: string;
      lastName: string;
      companyName: string;
      representativesFirstName: string;
      representativesLastName: string;
      /** @enum {string} */
      program?: "NONE" | "AFFILIATE" | "IB";
      phone?: string;
      isPhoneConfirmed: boolean;
      country: components["schemas"]["CountryResponseV3"];
      isOnboardingSuccessful: boolean;
      locale: string;
      preferableLang: string;
      siteId: number;
      nickName: string;
      agreementSigned: boolean;
      createdAt: string;
      manager?: components["schemas"]["AffManagerResponseDto"];
      contacts: components["schemas"]["AlternativeContactResponseDto"][];
      isDocsVerified: boolean;
    };
    UpdateProfileQueryDto: {
      phone?: string;
      locale?: string;
      firstName?: string;
      lastName?: string;
      companyName?: string;
      nickName?: string;
      representativesFirstName?: string;
      representativesLastName?: string;
      countryCode?: string;
      /** Format: date-time */
      dateOfBirth?: string;
      contacts?: components["schemas"]["AlternativeContactQueryDto"][];
    };
    ChangePasswordQueryDto: {
      currentPassword: string;
      newPassword: string;
      newPasswordConfirm: string;
    };
    TicketCreatedQueryHook: {
      ticketId: number;
      requesterEmail: string;
      requesterExternalId: string;
    };
  };
}

export interface operations {
  ExportAffiliateMetricsController_exportMetrics: {
    parameters: {
      path: {
        exportType: string;
      };
      query: {
        groupBy:
          | "ByDay"
          | "ByWeek"
          | "ByMonth"
          | "ByCountry"
          | "ByRegulation"
          | "ByAffTrack"
          | "ByAffTrackAndDate"
          | "ByAffiliateModel"
          | "ByPlatformGroup"
          | "ByAdvertiser";
        dateStart?: string;
        dateEnd?: string;
        /** @deprecated */
        country?: number;
        /** @deprecated */
        affTrack?: string;
        tariff?: "standard" | "advanced";
        /** @deprecated */
        affModel?: "revenue" | "cpa" | "lot" | "spread";
        affModels?: ("revenue" | "cpa" | "lot" | "spread")[];
        sortBy?:
          | "AffTrack"
          | "Country"
          | "Date"
          | "IsRegulated"
          | "Clicks"
          | "Installs"
          | "Conversion"
          | "Deals"
          | "Deposits"
          | "Ftd"
          | "Profit"
          | "Registrations"
          | "Trials"
          | "Hits"
          | "Uniques"
          | "CombinedHits"
          | "CombinedRegistrations"
          | "CombinedUniques"
          | "Leads"
          | "AffModel"
          | "PlatformGroup"
          | "Advertiser";
        sortDirection?: "ASC" | "DESC";
        platformGroup?: (
          | "desktop"
          | "ios"
          | "android"
          | "pwa"
          | "other"
          | "web_mobile"
        )[];
        advertiserIds?: unknown[];
        affTracks?: unknown[];
        countries?: unknown[];
      };
    };
    responses: {
      200: {
        content: {
          "application/csv": string;
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": string;
        };
      };
    };
  };
  ExportMobileMetricsController_exportMetrics: {
    parameters: {
      path: {
        exportType: string;
      };
      query: {
        groupBy:
          | "ByDay"
          | "ByWeek"
          | "ByMonth"
          | "ByCountry"
          | "ByRegulation"
          | "ByAffTrack"
          | "ByAffTrackAndDate"
          | "ByAffiliateModel"
          | "ByPlatformGroup"
          | "ByAdvertiser";
        dateStart?: string;
        dateEnd?: string;
        /** @deprecated */
        country?: number;
        /** @deprecated */
        affTrack?: string;
        tariff?: "standard" | "advanced";
        /** @deprecated */
        affModel?: "revenue" | "cpa" | "lot" | "spread";
        affModels?: ("revenue" | "cpa" | "lot" | "spread")[];
        sortBy?:
          | "AffTrack"
          | "Country"
          | "Date"
          | "IsRegulated"
          | "Clicks"
          | "Installs"
          | "Conversion"
          | "Deals"
          | "Deposits"
          | "Ftd"
          | "Profit"
          | "Registrations"
          | "Trials"
          | "Hits"
          | "Uniques"
          | "CombinedHits"
          | "CombinedRegistrations"
          | "CombinedUniques"
          | "Leads"
          | "AffModel"
          | "PlatformGroup"
          | "Advertiser";
        sortDirection?: "ASC" | "DESC";
        platformGroup?: (
          | "desktop"
          | "ios"
          | "android"
          | "pwa"
          | "other"
          | "web_mobile"
        )[];
        advertiserIds?: unknown[];
        affTracks?: unknown[];
        countries?: unknown[];
      };
    };
    responses: {
      200: {
        content: {
          "application/csv": string;
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": string;
        };
      };
    };
  };
  ExportTraderMetricsController_exportMetrics: {
    parameters: {
      path: {
        exportType: string;
      };
      query: {
        groupBy:
          | "ByDay"
          | "ByTrader"
          | "ByWeek"
          | "ByMonth"
          | "ByCountry"
          | "ByAffTrack"
          | "ByAffiliateModel"
          | "ByAdvertiser"
          | "ByPlatform";
        registerDateStart?: string;
        registerDateEnd?: string;
        cpaDateStart?: string;
        cpaDateEnd?: string;
        metricsDateStart?: string;
        metricsDateEnd?: string;
        traderId?: number;
        /** @deprecated */
        country?: number;
        /** @deprecated */
        affTrack?: string;
        /** @deprecated */
        affModel?: "revenue" | "cpa" | "lot" | "spread";
        affModels?: ("revenue" | "cpa" | "lot" | "spread")[];
        tariff?: "standard" | "advanced";
        sortBy?:
          | "TraderId"
          | "Tariff"
          | "Country"
          | "RegisterDate"
          | "CpaDate"
          | "Platform"
          | "MetricsDate"
          | "Profit"
          | "Pnl"
          | "PnlRevenue"
          | "Deals"
          | "Deposits"
          | "Inout"
          | "CpaDealsAmount"
          | "AffTrack"
          | "AffModel"
          | "Advertiser"
          | "IsLead"
          | "DepositAmount";
        sortDirection?: "ASC" | "DESC";
        advertiserIds?: unknown[];
        affTracks?: unknown[];
        countries?: unknown[];
        isLead?: boolean;
        exportFields?: (
          | "traderId"
          | "affTrack"
          | "registerDate"
          | "metricsDate"
          | "cpaDate"
          | "tariff"
          | "country"
          | "platform"
          | "deposits"
          | "deals"
          | "inout"
          | "pnl"
          | "pnlRevenue"
          | "depositAmount"
          | "affModel"
          | "cpaDealsAmount"
          | "profit"
          | "advertiserId"
          | "isLead"
        )[];
      };
    };
    responses: {
      200: {
        content: {
          "application/csv": string;
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": string;
        };
      };
    };
  };
  TraderMetricsSettingsController_getSettings: {
    parameters: {
      query: {
        groupBy?:
          | "ByDay"
          | "ByTrader"
          | "ByWeek"
          | "ByMonth"
          | "ByCountry"
          | "ByAffTrack"
          | "ByAffiliateModel"
          | "ByAdvertiser"
          | "ByPlatform";
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["TraderMetricsSettingsResponse"][];
        };
      };
    };
  };
  AffiliateMetricsSettingsController_getSettings: {
    parameters: {
      query: {
        groupBy?:
          | "ByDay"
          | "ByWeek"
          | "ByMonth"
          | "ByCountry"
          | "ByRegulation"
          | "ByAffTrack"
          | "ByAffTrackAndDate"
          | "ByAffiliateModel"
          | "ByPlatformGroup"
          | "ByAdvertiser";
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["AffiliateMetricsSettingsResponse"][];
        };
      };
    };
  };
  PingController_ping: {
    parameters: {};
    responses: {
      200: unknown;
    };
  };
  SignupController_signup: {
    parameters: {
      header: {
        "X-GEOIP-COUNTRY-CODE": string;
      };
    };
    responses: {
      201: unknown;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["SignupDto"];
      };
    };
  };
  EmailConfirmController_confirm: {
    parameters: {};
    responses: {
      200: unknown;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["EmailConfirmDto"];
      };
    };
  };
  EmailConfirmController_request: {
    parameters: {};
    responses: {
      200: unknown;
    };
  };
  ResetPasswordController_request: {
    parameters: {};
    responses: {
      204: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["RequestResetPasswordDto"];
      };
    };
  };
  ResetPasswordController_reset: {
    parameters: {};
    responses: {
      204: never;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["ResetPasswordDto"];
      };
    };
  };
  CountriesController_countries: {
    parameters: {
      query: {
        /** program for filters countries */
        restrictedProgram?: "NONE" | "AFFILIATE" | "IB";
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["CountryResponseDto"][];
        };
      };
    };
  };
  CountriesV3Controller_countries: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["CountryResponseV3"][];
        };
      };
    };
  };
  CountriesV3IpController_countries: {
    parameters: {
      header: {
        "X-GEOIP-COUNTRY-CODE": string;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["CountryResponseV3Ip"];
        };
      };
    };
  };
  OnboardingController_pass: {
    parameters: {};
    responses: {
      204: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["OnboardingQueryDto"];
      };
    };
  };
  OnboardingController_preferableLanguages: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["LanguagesResponseDto"][];
        };
      };
    };
  };
  PhoneController_requestAdding: {
    parameters: {};
    responses: {
      204: never;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
      401: unknown;
      403: unknown;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["RequestPhoneAddingDto"];
      };
    };
  };
  PhoneController_requestRemoving: {
    parameters: {};
    responses: {
      204: never;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
      401: unknown;
      403: unknown;
    };
  };
  PhoneController_remove: {
    parameters: {};
    responses: {
      204: never;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
      401: unknown;
      403: unknown;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["ConfirmPhoneRemoveDto"];
      };
    };
  };
  PhoneController_add: {
    parameters: {};
    responses: {
      204: never;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
      401: unknown;
      403: unknown;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["ConfirmPhoneAddDto"];
      };
    };
  };
  SubscriptionController_newsletter: {
    parameters: {};
    responses: {
      204: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["SubscriptionNewsletterQueryDto"];
      };
    };
  };
  AffTracksController_getAffTracks: {
    parameters: {
      query: {
        search: string;
        limit: number;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": string[];
        };
      };
    };
  };
  AffTracksController_getReferralsAffTracks: {
    parameters: {
      query: {
        search: string;
        limit: number;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": string[];
        };
      };
    };
  };
  AffiliateController_getAffiliate: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["AffiliateResponseDto"];
        };
      };
      401: unknown;
      404: unknown;
    };
  };
  AffiliateController_updateProfile: {
    parameters: {};
    responses: {
      204: never;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
      401: unknown;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["UpdateProfileQueryDto"];
      };
    };
  };
  ChangePasswordController_post: {
    parameters: {};
    responses: {
      204: never;
      400: {
        content: {
          "application/json": components["schemas"]["ErrorResponseDto"];
        };
      };
      401: unknown;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["ChangePasswordQueryDto"];
      };
    };
  };
  PaymentAccountController_confirm: {
    parameters: {
      path: {
        token: string;
      };
    };
    responses: {
      302: never;
    };
  };
  AccessController_getToken: {
    parameters: {};
    responses: {
      302: never;
    };
  };
  LogoutController_getToken: {
    parameters: {};
    responses: {
      302: never;
    };
  };
  AssignController_getToken: {
    parameters: {};
    responses: {
      204: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["TicketCreatedQueryHook"];
      };
    };
  };
  PaymentAccountControllerV3_confirm: {
    parameters: {
      path: {
        token: string;
      };
    };
    responses: {
      200: unknown;
    };
  };
}

export interface external {}

export enum ApiPaths {
  ExportAffiliateMetricsController_exportMetrics = "/api/statistics/affiliate/export/:exportType",
  ExportMobileMetricsController_exportMetrics = "/api/statistics/mobile/export/:exportType",
  ExportTraderMetricsController_exportMetrics = "/api/statistics/trader/export/:exportType",
  TraderMetricsSettingsController_getSettings = "/api/v3/statistics/trader/settings",
  AffiliateMetricsSettingsController_getSettings = "/api/v3/statistics/affiliate/settings",
  PingController_ping = "/api/ping",
  SignupController_signup = "/api/auth/signup",
  EmailConfirmController_confirm = "/api/auth/email-confirm",
  EmailConfirmController_request = "/api/auth/email-confirm/request",
  ResetPasswordController_request = "/api/auth/reset-password/request",
  ResetPasswordController_reset = "/api/auth/reset-password/reset",
  CountriesController_countries = "/api/dictionary/countries",
  CountriesV3Controller_countries = "/api/v3/countries",
  CountriesV3IpController_countries = "/api/v3/country-ip",
  OnboardingController_pass = "/api/v3/user/onboarding",
  OnboardingController_preferableLanguages = "/api/v3/user/onboarding/support-languages",
  PhoneController_requestAdding = "/api/v3/user/phone/request-adding",
  PhoneController_requestRemoving = "/api/v3/user/phone/request-removing",
  PhoneController_remove = "/api/v3/user/phone/remove",
  PhoneController_add = "/api/v3/user/phone/add",
  SubscriptionController_newsletter = "/api/v3/user/subscription/newsletter",
  AffTracksController_getAffTracks = "/api/v3/statistics/afftracks",
  AffTracksController_getReferralsAffTracks = "/api/v3/statistics/referrals/afftracks",
  AffiliateController_getAffiliate = "/api/v3/user",
  AffiliateController_updateProfile = "/api/v3/user",
  ChangePasswordController_post = "/api/v3/auth/reset-password",
  PaymentAccountController_confirm = "/api/payment-account/confirm/:token",
  AccessController_getToken = "/api/support/access",
  LogoutController_getToken = "/api/support/logout",
  AssignController_getToken = "/api/support/assign/manager",
  PaymentAccountControllerV3_confirm = "/api/v3/payment-account/confirm/:token",
}
